// Auto-generated normalizer for table: Lecciones
export function leccionesNormalize(row) {
  return {
    idLeccion: row.idLeccion ?? row.IdLeccion ?? row['IdLeccion'] ?? 0,
    idModulo: row.idModulo ?? row.IdModulo ?? row['IdModulo'] ?? 0,
    titulo: row.titulo ?? row.Titulo ?? row['Titulo'] ?? '',
    monedas: row.monedas ?? row.Monedas ?? row['Monedas'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
